import { Progress, Card, Row, Col } from 'antd'
import Logs from '../Logs'
import { downloadFile } from 'Services/WeaverUtils'
import moment from 'moment'
import { useQuery } from '@tanstack/react-query'

const statusMap = {
  'running': 'active',
  'pending': 'normal',
  'errored': 'exception',
  'success': 'success'
}

const getColor = (status) => {
  if (status === 'success') {
    return '#52c41a'
  } else if (status === 'errored') {
    return '#eb3c3c'
  }
}

const Description = ({ orchestrator, started, stopped, status, uid, inputFileId, resultFileId }) => {

  const inputFile = useQuery(
    [`pipelines.jobs.${uid}.inputFile.${inputFileId}`],
    () => inputFileId ? Weaver.File.load(inputFileId) : false
  )

  const resultFile = useQuery(
    [`pipelines.jobs.${uid}.resultFile.${resultFileId}`],
    () => resultFileId ? Weaver.File.load(resultFileId) : false
  )

  const renderDownloadLink = (fileId, file) => {
    return (
      <Col span={12}>
        <a onClick={() => downloadFile(fileId)}>Download {file.name()}</a>
      </Col>
    )
  }

  const renderStopped = () => (
    <>
      <Col span={12}>Stopped: {stopped}</Col>
      { (!resultFile.isLoading && !_.isEmpty(resultFile.data)) ? renderDownloadLink(resultFileId, resultFile.data) : null }
    </>
  )

  return (
    <>
      <Row>
        <Col span={12}>Status: {_.startCase(status)}</Col>
        <Col span={12}><Logs orchestrator={orchestrator} uid={uid}/></Col>
      </Row>
      <Row>
        <Col span={12}>Started: {started}</Col>
        <Col span={12}>
          { (!inputFile.isLoading && !_.isEmpty(inputFile.data)) ? renderDownloadLink(inputFileId, inputFile.data) : null }
        </Col>
      </Row>
      <Row>
        { stopped != '-' ? renderStopped() : ' ' }
      </Row>
    </>
  )
}

// TODO: Add Duration
export default function ({ job, orchestrator }) {

  const { uid, started, stopped, resultFileId, inputFileId, progress = 0, status = "pending" } = job;

  return (
    <Card
      key={uid}
      style={{ width: '100%' }}
    >
      <Card.Meta
        style={{ display: 'flex', alignItems: 'center' }}
        avatar={
          <Progress
            type="circle"
            status={statusMap[status]}
            percent={progress}
            style={{ color: `${getColor(status)}` }}
            size="small"
            width={50}
          />
        }
        description={
          <Description
            orchestrator={orchestrator}
            started={started ? moment.utc(started, "YYYY-MM-DDTHH:mm:ss.SSSSZ").format("ddd, DD MMM YYYY, HH:mm") : '-'}
            stopped={stopped ? moment.utc(stopped, "YYYY-MM-DDTHH:mm:ss.SSSSZ").format("ddd, DD MMM YYYY, HH:mm") : '-'}
            status={status}
            uid={uid}
            resultFileId={resultFileId}
            inputFileId={inputFileId}
          />
        }
      />
    </Card>
  )
}
